import React, { Component } from "react";
import TableBox from "../components/Table/TableBox";
import { fetchApi } from "../utils/DatabaseHelper";

/**
 * E-Mail-Verlauf Seite.
 * Nutzt die generische TableBox, damit Layout, Filter und Tabelle
 * dem Rest der Anwendung (z. B. Tätigkeiten/Bereiche) entsprechen.
 */
class EmailVerlauf extends Component {
  state = { firmenOptions: [] };

  componentDidMount() {
    fetchApi("firmen", "", { limit: "ALL" })
      .then((resp) =>
        this.setState({
          firmenOptions: resp.data
            .map((f) => ({ value: f.id, label: f.name }))
            .sort((a, b) => a.label.localeCompare(b.label)),
        }),
      )
      .catch(() => {});
  }

  render() {
    return (
      <TableBox
        resourceName="emailLog"
        schema={this.props.schemas?.emailLog}
        disableFilter={true}
        rowClicks={false}
        setCsvQuery={() => {}}
        filterOptions={{ firmenId: this.state.firmenOptions }}
      />
    );
  }
}

export default EmailVerlauf;
